import styled from '@emotion/styled'
import { colors, typo } from '@mathflat/common/style'

export const S = {
  Container: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: var(--Radius-100);
    border: 1px solid ${colors.gray.$400};
    background: #fff;
    padding: 4px;
  `,

  TabItem: styled.div`
    input {
      display: none;

      &:checked + label {
        border-radius: var(--Radius-100);
        background: ${colors.gray.$200};
        color: ${colors.gray.$900};
        font-weight: 700;
      }
    }

    label {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 100%;
      padding: 0 12px;
      ${typo.body02};
      font-weight: 400;
      color: ${colors.gray.$600};
      cursor: pointer;
    }
  `,
}
